import React, { Component } from 'react';

import { s3CacheUrl } from '../Common/util';

export class KreimerQuote extends Component {
  render() {
    return(
      <div className={"collabs-banner-quote kreimer-fg tile is-5"}>
        {`“I loved the way painters like Vuillard and Fairfield Porter would depict rugs, upholstery and textiles. That became a major formal interest in my paintings.”`}
        <div className={"collabs-banner-byline"}>
          —Julian Kreimer
        </div>
      </div>
    );
  }
}

export class KreimerBio extends Component {
  render() {
    return(
      <div className={"collabs-bio"}>
        <div className={"collabs-divider kreimer-bg"} />

        <div className={"collabs-section white white tile is-ancestor"}>
          <div className={'collabs-bio-image-container tile is-5'}>
            <img className={"collabs-bio-image"} alt={"Julian Kreimer"} src={s3CacheUrl("https://s3.amazonaws.com/weft-public-assets/images/weft-shop-collab/kreimer/kreimer1weft-artist-portrait-388x350.jpg", 350)} />
          </div>
          <div className={"collabs-bio-header tile is-5"}>
            <h1>Negative Space as Structure</h1>
            <p>In both his abstract and observational work, Julian Kreimer explores negative space and figure-ground relationships.</p>
          </div>
        </div>

        <div className={"collabs-section grey"}>
          <div className={"bio-content"}>
            <p>In creating his painting and drawings, artist Julian Kreimer works in two distinct modes: 
            Abstraction and observation. Of the latter he notes, “I paint plein-air, one shot 
            paintings of everyday stuff around me, roads, buildings, parking lots, the strip 
            of woods between the highway and suburban backyards.” He continues, “Humdrum stuff, 
            but I'm kind of a pantheist and all that stuff has a spark in it.”</p>
 
            <p>Yet it’s through this observational work that Kreimer often finds inspiration 
            for his abstract pieces. He explains, “When I'm painting outside, there are all 
              kinds of thoughts and visual ideas that can't make it into the paintings, since 
            they are about depicting only what's there, so I cram all those other thoughts 
            into my abstractions, and let them pile up, and cut into them, treating them 
            almost like a woven textile.”</p>
 
            <p>Fittingly, then, it was through working in the mode of abstraction that Kreimer 
            created his design with Weft; it’s inspired by a series of drawings wherein 
            Kreimer used a colored pencil on handmade abaca fiber paper to create, then 
            erase, a series of designs. Eventually, these erasures became design structures, 
            forming a pattern for jacquard fabric that cleverly exults in negative space.</p>
          </div>
        </div>
      </div>
    );
  }
}